export const SERVICE_IDS = [
  'crm',
  'erp',
  'processes',
  'finance',
  'realEstate',
  'hospitality',
  'mobile',
  'web',
  'reservations',
  'analytics',
  'loyalty',
  'marketing',
  'communication',
  'warehouse',
  'facility',
  'api',
  'cloud',
  'microsoft',
  'security',
  'custom',
  'training',
  'support',
] as const

export type ServiceId = (typeof SERVICE_IDS)[number]

export const FEATURED_SERVICE_IDS: readonly ServiceId[] = ['crm', 'hospitality', 'loyalty']
